import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import { R as N, T as h, C as R, a as E } from "./index.DmdlVKe8.js";
import * as d from "react";
import { B as T } from "./Button.Ccj-dDdM.js";
import { c as i } from "./index.CxSWpsOB.js";
const v = N, y = h, c = d.forwardRef(({
  children: o,
  className: r,
  shouldAnimate: s = !1,
  ...n
}, e) => /* @__PURE__ */ t.jsx(R, { ...n, ref: e, className: i(r, {
  "tw-transition-all data-[state=closed]:tw-animate-collapsible-up data-[state=open]:tw-animate-collapsible-down tw-overflow-hidden": s
}), children: o }));
c.displayName = E.displayName;
const O = ({
  children: o,
  openTriggerLabel: r = "",
  closeTriggerLabel: s = "",
  classNames: n,
  expandDown: e = !0,
  triggerShownBelowContent: l = !1,
  buttonAppearance: p = "black",
  buttonVariant: m = "default",
  hideButtonOnOpen: f = !1,
  onHandleToggle: u = () => {
  },
  shouldAnimate: b = !1
}) => {
  const [a, x] = d.useState(!1), C = a && f, w = () => {
    x(!a), u(!a);
  }, j = () => a && s ? s : r;
  return /* @__PURE__ */ t.jsxs(v, { open: a, onOpenChange: w, className: "tw-flex tw-flex-col tw-items-start", children: [
    /* @__PURE__ */ t.jsx(y, { asChild: !0, children: !C && /* @__PURE__ */ t.jsx(T, { variant: m, appearance: p, "aria-expanded": a, "aria-controls": "expandable-content", className: i("", {
      "tw-order-1": e && !(l && a),
      "tw-order-2": !e || l && a
    }, n), children: j() }) }),
    /* @__PURE__ */ t.jsx(c, { id: "expandable-content", className: i("tw-overflow-hidden tw-w-full", {
      "tw-order-2": e && !(l && a),
      "tw-order-1": !e || l && a
    }), shouldAnimate: b, children: o })
  ] });
};
O.displayName = "ExpandableContent";
export {
  v as C,
  O as E,
  c as a,
  y as b
};
//# sourceMappingURL=ExpandableContent.Cw-_R4is.js.map
